import {isCopilot} from '@github-ui/assignees/copilot-user'
import type {Reviewer} from '@github-ui/dotcom-schema/types/pull_requests/v1/reviewer'
import type {CopilotReviewerRow} from '@github-ui/dotcom-schema/types/pull_requests/v1/review_requests'

const COPILOT_REVIEWER_SLUG = 'copilot-pull-request-reviewer'

export function isCopilotPullRequestReviewer(reviewer: Pick<Reviewer, 'slug'> | undefined): boolean {
  return normalizeReviewerSlug(reviewer?.slug) === COPILOT_REVIEWER_SLUG
}

export function isCopilotReviewer(reviewer: Pick<Reviewer, 'displayLogin' | 'slug'> | undefined): boolean {
  return isCopilotPullRequestReviewer(reviewer) || isCopilot(reviewer?.displayLogin ?? '')
}

export function normalizeReviewerSlug(slug: string | null | undefined): string {
  return (slug ?? '').replace(/\[bot\]$/, '')
}

export function matchesCopilotReviewerRow(
  reviewer: Reviewer | undefined,
  row: CopilotReviewerRow | undefined,
): boolean {
  const rowReviewer = row?.reviewer
  if (!reviewer || !rowReviewer || reviewer.reviewerType !== rowReviewer.reviewerType) return false

  const matchingId = reviewer.id !== 0n && rowReviewer.id !== 0n && reviewer.id === rowReviewer.id
  const reviewerSlug = normalizeReviewerSlug(reviewer.slug)
  const matchingSlug = reviewerSlug !== '' && reviewerSlug === normalizeReviewerSlug(rowReviewer.slug)
  return matchingId || matchingSlug
}
